import { last, split, toNumber, toString } from 'lodash-es'

/**
 * 判断是否同一个路由
 * @param pathName
 * @param href
 * @returns boolean
 */
export function routeMatch(pathName: string, href: string) {
  const normalizedPathName = pathName.replace(/^\/+/, '')
  const normalizedHref = href.replace(/^\/+/, '')
  if (normalizedPathName === normalizedHref) {
    return true
  } else if (normalizedHref && normalizedPathName.startsWith(normalizedHref)) {
    return true
  }
  return false
}

/**
 * 生成slug
 * @param strs
 * @returns
 */
export function toSlug(...strs: any[]): string {
  // 如果只有一个参数且是数组，处理数组情况
  if (strs.length === 1 && Array.isArray(strs[0])) {
    return strs[0].map((item) => toSlug(item)).join('-')
  }

  // 处理多个参数的情况
  if (strs.length > 1) {
    return strs.map((item) => toSlug(item)).join('-')
  }

  // 处理单个值的情况
  return toString(strs[0])
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

/**
 * slug生成id
 * @param slug
 * @returns
 */
export function slugToId(slug?: string) {
  if (slug === undefined) {
    return
  }
  return toNumber(last(split(slug, '-')))
}
